import { getColorByTypologie } from './index';

const textureHachuresUrl =
  'https://medias.ev3d.com/common/imgs/micro-hachures.png';

export default function getSceneDefinition(
  fov,
  fullpath,
  frames,
  _sprites,
  _zones,
  fps,
  loDef,
  hiDef,
  settings,
  hasAlphas = false,
  useOpacity = true,
  theme,
) {
  let framesArray = Array(fps).fill([0, 0, 0, 0, 0, 0]);
  let zones = [];
  let sprites = [];

  const isTypeTerrain = settings?.maquette?.type === 'terrain';

  if (frames && frames.length === fps) {
    framesArray = frames.map((f) => f.map(parseFloat));
  }

  if (_sprites && _sprites.length > 0) {
    sprites = _sprites.map((s) => {
      return {
        key: s.key,
        style: {
          url: '/pin.png',
          scale: 40,
          opacity: 0.8,
          active: {
            scale: 50,
          },
        },
        coords: s.coords.position.map((i) => i / 10),
        data: { key: s.key },
      };
    });
  }
  if (_zones) {
    zones = _zones.map(({ key, lot, shapes, style }) =>
      getZoneDefinition(
        settings,
        lot,
        isTypeTerrain,
        useOpacity,
        key,
        shapes,
        theme,
        style,
      ),
    );
  }
  return {
    frames: framesArray,
    fov,
    zones,
    sprites,
    fullpath,
    hasAlphas,
    fps,
    loDef,
    hiDef,
  };
}

function getZoneDefinition(
  settings,
  lot,
  isTypeTerrain,
  useOpacity,
  key,
  shapes,
  theme,
  style,
) {
  console.log('lot', lot);
  return {
    key,
    data: lot,
    label:
      settings?.maquette?.showLabelzoneDefinition && lot?.nom ? lot.nom : null,
    coords: shapes.map((s) => s.map((c) => c.map(parseFloat))),
    style: style || {
      textureUrl: lot?.statut_id > 2 || !lot ? textureHachuresUrl : null,
      color: lot ? getColorByTypologie(lot?.type, theme) : '#969696',
      opacity: isTypeTerrain && useOpacity ? 0 : lot ? 0.5 : 0.25,
      label: {
        height: 20,
      },
      line: {
        color: '#e0e0e0',
        linewidth: isTypeTerrain ? 2 : 0,
      },
      active: {
        opacity: isTypeTerrain ? 0.4 : lot ? 0.8 : 0.5,
        blink: '#eeeeee',
      },
    },
  };
}
